import { modifier } from 'ember-modifier';

/**
 * MAP (in-file navigation graph — keep in sync with the code):
 *   role:      modifier — makes a clickable non-button element (span/div with {{on 'click'}} or a
 *              Foundation `data-toggle` opener) usable from the keyboard: focusable (tabindex 0, role button
 *              when none is set) and activated by Enter / Space exactly like a click.
 *   usage:     `<span role='button' data-toggle='…' {{nv-key-activate}}>` — keep the existing click handler.
 *   why:       hard-cases audit 2026-10-15: invoice-line «⋮» menu, number prefix/suffix, «solo questa stanza»
 *              were unreachable by keyboard.
 *   gotchas:   Space scrolls the page by default: prevented. A key on a child control (an input inside the
 *              element) is left alone. element.click() bubbles to <body>, so body-click openers
 *              (application route _handleBodyClick) open their pane as on a mouse click.
 */
var nvKeyActivate = modifier(element => {
  if (!element.hasAttribute('tabindex')) element.setAttribute('tabindex', '0');
  if (!element.hasAttribute('role')) element.setAttribute('role', 'button');
  const onKeydown = event => {
    if (event.target !== element) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    element.click();
  };
  element.addEventListener('keydown', onKeydown);
  return () => element.removeEventListener('keydown', onKeydown);
});

export { nvKeyActivate as default };
//# sourceMappingURL=nv-key-activate.js.map
